import { userConstants } from "../constants/login.constants";

 function loggedUserInfo(state = {}, action) {
    switch (action.type) {
        case userConstants.LOGINUSERINFO_REQUEST:
            return {
                loading: true
            };
        case userConstants.LOGINUSERINFO_SUCCESS:
            return {
                items: action.loggedUserInfo
            };
        case userConstants.LOGINUSERINFO_FAILURE:
            return {
                error: action.loggedUserInfoError
            };
        default:
            return state
    }
}
export default loggedUserInfo;